import { useEffect, useState } from 'react';
import CrudPage from './CrudPage';
import { api } from '@/lib/api';

export default function Tasks() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get('/users').then(({ data }) => setUsers(data)).catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CrudPage
      title="المهام"
      subtitle="Tasks & Follow-ups"
      endpoint="tasks"
      testId="tasks-page"
      defaultForm={{ status: 'open', priority: 'medium' }}
      columns={[
        { key: 'title', label: 'المهمة' },
        { key: 'assigned_to', label: 'المسند إلى' },
        { key: 'due_date', label: 'الاستحقاق' },
        { key: 'priority', label: 'الأولوية' },
        { key: 'status', label: 'الحالة' },
      ]}
      fields={[
        { key: 'title', label: 'العنوان', full: true },
        { key: 'description', label: 'الوصف', type: 'textarea', full: true },
        { key: 'assigned_to', label: 'مسند إلى', type: 'select', options: users.map(u => ({ value: u.name, label: u.name })) },
        { key: 'due_date', label: 'تاريخ الاستحقاق', type: 'date' },
        { key: 'priority', label: 'الأولوية', type: 'select', options: [
          { value: 'low', label: 'منخفضة' }, { value: 'medium', label: 'متوسطة' }, { value: 'high', label: 'عالية' },
        ]},
        { key: 'status', label: 'الحالة', type: 'select', options: [
          { value: 'open', label: 'مفتوحة' }, { value: 'in_progress', label: 'قيد التنفيذ' },
          { value: 'done', label: 'منجزة' }, { value: 'cancelled', label: 'ملغية' },
        ]},
      ]}
    />
  );
}
